<template>
  <div class="coupon-code__container">
    <div class="toggle-coupon">
      <input id="register-coupon-code" type="checkbox" v-model="useCouponCode"/>
      <label for="register-coupon-code">{{ $t('I have a discount code') }}</label>
    </div>
    <span class="_loading" v-show="couponRequestIsLoading"></span>
    <div class="coupon-code__form" v-show="useCouponCode && !couponRequestIsLoading">
      <input type="text" id="coupon-code" name="coupon_code" v-model="couponCodeInput" v-show="!couponStatus" @keyup.enter.prevent="applyCouponCode"/>
      <button type="button" class="_button" @click="applyCouponCode" v-show="!couponStatus" :disabled="couponRequestIsLoading">{{ $t('Apply') }}</button>
      <button type="button" class="_button" @click="cancelCouponCode" v-show="couponStatus" :disabled="couponRequestIsLoading">{{ $t('Cancel') }}</button>
      <span class="field-success" v-show="couponStatus">{{ $t('Your applied coupon code is {couponCodeInput}.', { couponCodeInput: couponCodeInput }) }}</span>
      <span class="field-error" v-show="!couponStatus">{{ couponMessage }}</span>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';

  @Component({
    name: 'checkout-coupon-form'
  })

  export default class extends Vue {
    @Prop({default: false}) private reloadOnSuccess: boolean;
    private useCouponCode: boolean = false;
    private couponCodeInput: string = '';

    @Watch('useCouponCode')
    private useCouponCodeHandler(nv): void {
      if (!nv) {
        this.cancelCouponCode();
      }
    }

    @Watch('couponCode')
    private couponCodeHandler(nv, ov): void {
      if (nv !== ov) {
        this.couponCodeInput = nv;
      }
    }

    private get couponCode(): string {
      return this.$store.state.CheckoutPayment.couponCode;
    }

    private get couponRequestIsLoading(): boolean {
      return this.$store.state.CheckoutPayment.couponRequestIsLoading;
    }

    private get couponStatus(): null | boolean {
      return this.$store.state.CheckoutPayment.couponStatus;
    }

    private get couponMessage(): string {
      return this.$store.state.CheckoutPayment.couponMessage;
    }

    private async applyCouponCode(): Promise<void> {
      await this.$store.dispatch('CheckoutPayment/applyCouponCode', this.couponCodeInput);
      if (this.reloadOnSuccess && this.couponStatus) {
        window.location.reload();
      }
    }

    private async cancelCouponCode(): Promise<void> {
      const hadCoupon = Boolean(this.couponStatus);
      await this.$store.dispatch('CheckoutPayment/removeCouponCode');
      if (this.reloadOnSuccess && hadCoupon) {
        window.location.reload();
      }
    }

    private async created(): Promise<any> {
      const hasCoupon = await this.$store.dispatch('CheckoutPayment/getCouponCode');
      if (hasCoupon || this.couponCode.length) {
        this.couponCodeInput = this.couponCode;
        this.useCouponCode = true;
      }
    }
  }
</script>
